import React from 'react'
import LogoSvg from '../VectorImage/LogoSvg'
import './Logo.scss'

export const Logo = React.memo(({ theme }) => {
  return <LogoSvg className={`iliad__logo iliad__logo--${theme}`} />
})

export default Logo
